export default "__VITE_ASSET__3fba5dca__"